<div
  *ngIf="(previousJob$ | async) && (jobsInDepartment$ | async)"
  class="previous-job-counter"
  (click)="$event.stopPropagation(); openPreviousJobsSheet()"
  [matTooltip]="'previousJobsInThisDepartmentOfLast3Months' | i18n"
  matTooltipPosition="above">
  <mat-icon
    class="size-20"
    svgIcon="suitcase-job-history-clock"></mat-icon>
  <span>{{
    (jobsInDepartment$ | async) + " / " + (jobsInOrganisation$ | async)
  }}</span>
</div>
<div
  *ngIf="(previousJob$ | async) && (employmentsInDepartment$ | async)"
  class="previous-job-counter"
  (click)="$event.stopPropagation(); openPreviousJobsEmploymentsSheet()"
  [matTooltip]="'previousEmploymentsInThisDepartmentOfLast3Months' | i18n"
  matTooltipPosition="above">
  <mat-icon
    class="size-20"
    svgIcon="pending-actions"></mat-icon>
  <span>{{
    (employmentsInDepartment$ | async) +
      " / " +
      (employmentsInOrganisation$ | async)
  }}</span>
</div>
